import EditUser from "pages/AtPort/EditUser";
import User from "pages/AtPort/User";

const AtPort = {
  User,
  EditUser,
};

export default AtPort;
